// Print version of the Referees tab: a page per referee

import { Fragment } from 'react';
import GameReportGroup from './GameReportGroup';
import GameReportSection from './GameReportSection';
import GameReportPageTop from './GameReportPageTop';
import { useGameReport } from '../utils/hooks';
import {
  getGamesByDay,
  countGames,
  totalGamesOn,
  totalGamesOf,
  gameRate,
  hasRates,
  moneyStr,
  sumPay,
  totalPayOn,
  totalPayOf,
} from '../utils/gameReport';
import './GameReportPDF.scss';

// The rates come from the Referees tab rather than from `useRefereeRates`, so
// the amounts typed there and not yet read back print too
export default function RefereeReportPDF({
  id,
  colorLegend,
  getRates,
  isRatesSynced,
}) {
  const {
    days,
    sortedGames,
    sortedFields,
    gamesReferees,
    hasRefereedDivision,
    getRefereeName,
  } = useGameReport(id);

  return (
    <div className='game-report-pdf'>
      {gamesReferees.map((referee) => {
        const gamesByDay = getGamesByDay(sortedGames, referee, days);
        const refereeName = getRefereeName(referee);
        const rates = getRates(referee);
        // A referee nobody has priced prints exactly as before, without an
        // empty Rate column running down the page
        const showPay = isRatesSynced && hasRates(rates);

        return (
          <Fragment key={referee}>
            <GameReportPageTop id={id} colorLegend={colorLegend} newPage />
            <GameReportGroup
              title={refereeName}
              total={totalGamesOf(refereeName, countGames(gamesByDay))}
              totalPay={
                showPay &&
                totalPayOf(
                  refereeName,
                  gamesByDay.reduce(
                    (pay, { games }) => pay + sumPay(games, rates),
                    0,
                  ),
                )
              }
            >
              {gamesByDay.map(({ day, games }, dayIndex) => (
                <GameReportSection
                  key={dayIndex}
                  title={day.format('MMMM D, YY')}
                  total={totalGamesOn(day.format('MMMM D'), games.length)}
                  totalPay={
                    showPay &&
                    totalPayOn(day.format('MMMM D'), sumPay(games, rates))
                  }
                  games={games}
                  fields={sortedFields}
                  colorLegend={colorLegend}
                  noDivisionCol={!hasRefereedDivision}
                  noGameCol
                  noScoreCol
                  noRefereeCol
                  renderRate={
                    showPay
                      ? (game) => moneyStr(gameRate(rates, game.id) || 0)
                      : undefined
                  }
                />
              ))}
            </GameReportGroup>
          </Fragment>
        );
      })}
    </div>
  );
}
